import type { TimelineRowType } from '../useTimelineTableColumns';

export const collectRenderedItemIds = (rows: TimelineRowType[]): Set<number> => {
  const ids = new Set<number>();
  const visit = (currentRows: TimelineRowType[]) => {
    for (const row of currentRows) {
      for (const item of row.allItems ?? []) {
        ids.add(item.id);
        for (const child of item.children ?? []) ids.add(child.id);
      }
      if (row.subRows) visit(row.subRows);
    }
  };
  visit(rows);
  return ids;
};
